import {useState} from "react"; 
import { Link } from "react-router-dom";
import './PhoneticsChart.css';
import { ConsonantBasic, ConsonantComplex, VowelBasic, VowelComplex } from "../SubjectData/Phonetics/Phonetics.js";
import HeaderNav from "../Components/Header/Header_Nav/Header_Nav.js";
import Footer from "../Components/Footer/Footer.js";


export default function PhoneticsChart() {
  
    const [openPopup, setOpenPopup] = useState(null);
    //store states in an array

    //use state creates state variable
    //make initial value of state null--> not open when popup first loads
    //if state is null or false, nothing is rendered

    //define two state: openPopup and setOpenPopup

    //inset setOpenPopup into an html element to change the current state
    
    return (
    
    <div>
        
          <HeaderNav GoBack_to={"/"}/>
        
      <div className="BelowBanner-phon">

        <div className="SubheaderContainer">
            <h1 className = "subheader-phon">Basic Consonants</h1>
            
            <Link to="/ConsonantBasicDeck"><p className="SeeDeck">
                Go to Deck</p></Link>
        </div>
        
        
        {/*Basic Consonants*/}

        <div className="CardContainer-phon">
            
            {/* map function to iterate through the array */}
            {ConsonantBasic.map(
                (a) => (
                    <div className="Card-phon" 
                         key={a.id} 
                         onClick={()=>setOpenPopup(a)}>
                        <div className="CardSymbol-phon">{a.korean}</div>
                        <h2 className="CardPhonetic-phon">{a.english}</h2>
                    </div>
                )
            )
            }    
        </div>

        <div className="SubheaderContainer">
            <h1 className = "subheader-phon">Double (Tensed) Consonants</h1>
            
            <Link to="/ConsonantComplexDeck"><p className="SeeDeck">
                Go to Deck</p></Link>
        </div>


        <div className="CardContainer-phon">

            {/*Complex Consonants*/}
            
            {/* map function to iterate through the array */}
            {ConsonantComplex.map(
                
                /* a is placeholder for array object 
                    next will be passed into OpenPopup, array elements pulled
                    by {placeholder.arrayElementName}
                */
                
                    (a) => (
                    <div className="Card-phon" 
                         onClick={()=>setOpenPopup(a)}
                         key={a.id}>

                        <div className="CardSymbol-phon">{a.korean}</div>
                        <p className="CardPhonetic-phon">{a.english}</p>
                    </div>
                )
            )
            }    
        </div>

        <div className="SubheaderContainer">
            <h1 className = "subheader-phon">Basic Vowels</h1>
            
            <Link to="/VowelBasicDeck"><p className="SeeDeck"> Go to Deck</p></Link>
        </div>
        
        {/*Basic Vowels*/}

        <div className="CardContainer-phon">
            
            {/* map function to iterate through the array */}
            {VowelBasic.map(
                (a) => (
                    <div 
                    className="Card-phon" 
                    onClick={()=>setOpenPopup(a)}
                    key={a.id}>
                        <div className="CardSymbol-phon">{a.korean}</div>
                        <p className="CardPhonetic-phon">{a.english}</p>
                    </div>
                )
            )
            }    
        </div>

        <div className="SubheaderContainer">
            <h1 className = "subheader-phon">Complex Vowels</h1>
            
            <Link to="/VowelComplexDeck"><p className="SeeDeck">
                Go to Deck</p></Link>
        </div>

        <div className="CardContainer-phon">

            {/*Complex Consonants*/}
            
            {/* map function to iterate through the array */}
            {VowelComplex.map(
                (a) => (
                    <div 
                    className="Card-phon" 
                    onClick={()=>setOpenPopup(a)}
                    key={a.id}>
                        <div className="CardSymbol-phon">{a.korean}</div>
                        <p className="CardPhonetic-phon">{a.english}</p>
                    </div>
                )
            )
            }    
        
        </div>

        {/* Will only execute if openPop has value (not null or false) */}
        {openPopup && (
        
        <div className="PopupOverlay-phon" onClick={() => setOpenPopup(null)}>
            {/*clicking on overlay will close popup*/}
          
          <div className="Popup-phon" onClick={(e) => e.stopPropagation()}>
            {/* Pause onClick function while popUp open, prevent repeated executions */}
            
            
            <h2>{openPopup.korean}</h2>
            <p><strong>Phonetic:</strong> {openPopup.english}</p>
            <p><strong>Description:</strong> {openPopup.description}</p>
            
            {/*Exit*/}
            <button onClick={() => setOpenPopup(null)}>Close</button> 
          
          </div>
        
        </div>
      
      )}
      </div>

      <Footer/>

    </div>

    )
}


//Resources:

//How to make pop-ups in react":
    //****https://www.youtube.com/watch?v=LaHNqRlfH7A
    //Other, for css: https://dev.to/chukwuma1976/its-popping-pop-ups-made-simple-in-react-5cd8
//Overlays (css):
    //https://stackoverflow.com/koreans/9724035/how-can-one-create-an-overlay-in-css
    //https://www.w3schools.com/howto/howto_css_overlay.asp
